// src/utils/permissions.js

import { hasPermission } from "./permissionUtils";

// Editing company details is `manage_company_info` — the key
// PUT /api/settings/company-info enforces. The `role` argument is kept so
// existing callers don't change; it no longer decides anything.
export const canEditCompanyInfo = () => hasPermission("manage_company_info");

export const canViewCompanyInfo = (role) => {
  const r = (role || "").toLowerCase();
  return ["admin", "hr", "member"].includes(r);
};
